import config from "./config";
import { readData } from "../utils/fileHelpers";
import axios from "axios";

const uploadImage = async (folder, image) => {
  const imageData = await readData(image);

  const args = {
    Body: imageData,
    Key: folder,
    ContentType: image.type,
    ContentEncoding: "base64",

    // this means that the image is downloaded on click
    // instead of opening in browser
    ContentDisposition: `attachment; filename=${image.name}`,
  };

  const [url, params] = await config("putObject", args);

  return await axios.post(url, params);
};

export default uploadImage;
